var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.66634H2.33333V21.333H18.6667V7.33301H14V2.66634ZM0 1.49034C0 0.851008 0.5215 0.333008 1.1655 0.333008H15.1667L21 6.16634V22.4915C21.0011 22.6447 20.972 22.7966 20.9143 22.9386C20.8567 23.0806 20.7717 23.2098 20.6641 23.3189C20.5565 23.428 20.4285 23.5148 20.2873 23.5744C20.1462 23.634 19.9947 23.6653 19.8415 23.6663H1.1585C0.852108 23.6642 0.558854 23.5416 0.342087 23.3251C0.125321 23.1085 0.00244376 22.8154 0 22.509V1.49034ZM11.6667 11.9997V16.6663H9.33333V11.9997H5.83333L10.5 7.33301L15.1667 11.9997H11.6667Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.bd405ce101708cb96239dd501902ff0d.svg";
export { ForwardRef as ReactComponent };